import { evaluate } from 'mathjs'

export const evaluateFormula = (
    formula: string,
    inputValues: Record<string, number>,
    outputValues: Record<string, number>,
    logRoundDown: boolean = false,
    requiredFields: string[] = [],
    optionalFields: string[] = [],
    minVal?: number,
    maxVal?: number
): number => {
    let filledOptionalFields = fillOptionalFields(inputValues, optionalFields); // Fill optional fields with 0 if not provided
    const allValues = { ...inputValues, ...filledOptionalFields, ...outputValues }; // Combine both input and output values
    const valueKeys = Object.keys(allValues);

    let allRequiredPresent = requiredFields.every(field => 
        valueKeys.includes(field) && 
        allValues[field] !== undefined && 
        allValues[field] !== null && 
        !Number.isNaN(allValues[field]));
    if (!allRequiredPresent) {
        return NaN; //Stop processing if a required field is missing
    }

    const variableNames =
        formula.match(new RegExp(`\\b(${valueKeys.join('|')})\\b`, 'g')) ||
        [];

    for (let variable of variableNames) {
        const value = allValues[variable] ?? 0; // Default to 0
        formula = formula.replace(
            new RegExp(`\\b${variable}\\b`, 'g'),
            value.toString()
        );
    }

    //We are expecting 'LOG' from the formula in the DB. 
    //If it is lower case 'log', then the evaluate will default to 'ln', which we don't want
    if (formula.includes('LOG')) {
        formula = formula.replace("LOG", 'log10');
    }

    try {
        let result = evaluate(formula);
        if (logRoundDown) {
            result = Math.trunc(result);
        }
        if (result < 0) {
            result = 0;
        }
        if (!result)
            return result;
        if (minVal)
            result = Math.max(result, minVal);
        if(maxVal)
            result = Math.min(result, maxVal);
        return result;
    } catch (error) {
        return NaN; // Return NaN on error to differentiate from valid results
    }
};

function fillOptionalFields(inputValues: Record<string, number>, optionalFields: string[]): Record<string, number> {
    const filledOptionalFields: Record<string, number> = {};
    optionalFields.forEach(field => {
        if (inputValues[field] === undefined) {
            filledOptionalFields[field] = 0;
        }
    });
    return filledOptionalFields;
}

export function separateRequiredOptionalFields (descriptors: any[]): { requiredFields: string[], optionalFields: string[] } {
    const requiredFields = descriptors.filter(d => d.isRequired).map(d => d.inputId);
    const optionalFields = descriptors.filter(d => !d.isRequired).map(d => d.inputId);
    return { requiredFields, optionalFields };
};